/* ⚛ REACT */
import { useEffect, useRef, useState } from "react";

/* 📦 LIBS */
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

/* 🧩 COMPONENTS */
import { Button, InputSelect, Label, Modal, CustomLoading, Input, SaveIcon } from "../../../../Components";

/* 🔗 SERVICE */
import { PartsComandServices } from "../../../../Services/partscommandService";

/* 🧠 REDUX */
import { store } from "../../../../Redux/Store";
import { changeModal } from "../../../../Redux/Actions";

/* 🎨 STYLES */
import { Container, CountContainer, LineTitle, TitleText, LineList, ListText, PageTitle, ContainerList, 
    ContainerHead, ContainerRow, ButtonsContainer, ContainerColumn} from "./styles";

/* 🔧 UTILS */
import { isValidField } from "../../../../util/validate";

const ListPartsCommandsVariablesAlarms = () => {
    const { t } = useTranslation();

    document.title = "Ligação de alarmes e variáveis";
    const Services = useRef(new PartsComandServices());
    const [partCommands, setPartCommands] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [variables, setVariables] = useState([]);

    const targetField = useRef();
    const variableFiled = useRef();
    const typeField = useRef();

    const targetValue = useRef();
    const variableValue = useRef();
    const typeValue = useRef();

    useEffect(() => {
        async function getAllPartCommands(){
            let currentList = await Services.current.getPartCommandsVariablesAlarms();
            setPartCommands(currentList)
            setIsLoading(false)
        }

        async function getVariables(){
            let currentItem = await Services.current.getPartCommandsVariables();
            setVariables(currentItem);
        }

        getAllPartCommands();
        getVariables();
    },[])

    // Salva as edições do usuário
    async function Save(){
        store.dispatch(changeModal(''))
        if(isValidField(targetValue.current) && isValidField(variableValue.current) && isValidField(typeValue.current)){

            let form = new FormData();
            if(targetValue.current){form.append('target', targetValue.current)}
            if(variableValue.current){form.append('command_variable', variableValue.current)}
            if(typeValue.current){form.append('type', typeValue.current)}

    
            await Services.current.SavePartCommandVariableAlarm(form)
        }else{
            toast(t("message.save"), {
                position: "top-center",
                type: 'info',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
        }
    }

    return(
        <>
            <Container>
                <PageTitle>
                    Ligação de alarmes e variáveis
                </PageTitle>

                <ContainerHead>
                    <CountContainer>
                        {t("administrative.sub-items.list-total") + " " + partCommands.length + " Alarmes" }
                    </CountContainer>

                    <Button onClick={()=>store.dispatch(changeModal('newPartCommand'))} width={'fit-content'} color={'green'} icon={''} text={"+ Criar novo Alarme"}></Button>
                </ContainerHead>

                <ContainerList>
                    <LineTitle>
                        <TitleText>Alarme</TitleText>
                        <TitleText>Alvo</TitleText>
                        <TitleText>Tipo</TitleText>
                    </LineTitle>

                    {isLoading?
                        <CustomLoading width={'150px'} height={'150px'}/>
                    :
                        partCommands?.map((item, index)=>(
                            <LineList key={index} href={`/PartCommandsVariablesAlarms/${item.id}`}>
                                <ListText>{item.command_variable_name}</ListText>
                                <ListText>{item.target_name}</ListText>
                                <ListText>{item.type}</ListText>
                            </LineList>
                        ))
                    }
                </ContainerList>
            </Container>
            
            <Modal title={t("administrative.partCommands.add")} name={'newPartCommand'} width={'70%'} height={'90%'} >
                
                <ContainerRow onSubmit={(e)=> e.preventDefault()}>
                    <ContainerColumn>
                        <Label text={"Variável Alvo"} aling="flex-start"/>
                        <InputSelect
                            key={'target'}
                            name={'target'}
                            id={'target'}
                            placeholder={"Variável Alvo"}
                            invalidMessage = {"Variável Alvo inválida!"}
                            options={variables}
                            innerRef={targetField}
                            validationFunction = {(value) => isValidField(value)}
                            onchange={(value) => targetValue.current = value}>
                        </InputSelect>      

                        <Label text={t("inputs.type.label")} aling="flex-start"/>
                        <Input 
                            aling="flex-start"
                            id='type' 
                            name='type' 
                            type="text" 
                            placeholder= {t("inputs.type.placeholder")}
                            innerRef={typeField}
                            invalidMessage = {t("inputs.type.invalid-message")}
                            validationFunction = {(text) => isValidField(text)}
                            onchange={(text) => typeValue.current = text}> 
                        </Input>
                    </ContainerColumn>

                    <ContainerColumn>
                        <Label text={"Variável"} aling="flex-start"/>
                        <InputSelect
                            key={'variable'}
                            name={'variable'}
                            id={'variable'}
                            placeholder={"Variável"}
                            invalidMessage = {"Variável inválida!"}
                            options={variables}
                            innerRef={variableFiled}
                            validationFunction = {(value) => isValidField(value)}
                            onchange={(value) => variableValue.current = value}>
                        </InputSelect>
                    </ContainerColumn>
                </ContainerRow>

                
                <ButtonsContainer>
                    <Button text={t("buttons.save")} width={'150px'} icon={<SaveIcon/>} onClick={()=>Save()}/>
                    <Button text={t("buttons.cancel")} width={'150px'} color={'white-red'} onClick={()=>store.dispatch(changeModal(''))}/>
                </ButtonsContainer>
            </Modal>
        </>
    )
}

export default ListPartsCommandsVariablesAlarms;